import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { InputAdornment } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import s from "./SearchStudent.module.css";

const filter = createFilterOptions();
const ARIA_LABEL_AUTOCOMPLETE = "Search Students";

const renderOption = (currentActive) => (option) =>
  (
    <div
      role="option"
      aria-selected={currentActive === option.name}
      aria-label={`Select ${option.name}`}
    >
      {option.name}
    </div>
  );

function SearchStudent ({ students, onStudentSelected }) {
  const [optionSelected, setOptionSelected] = useState("");
  return (
    <div>
      <Autocomplete
        freeSolo
        size="small"
        options={students}
        getOptionLabel={(option) => (option.name ? option.name : option)}
        onChange={(_event, value) => onStudentSelected(value)}
        forcePopupIcon={false}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          if (filtered.length === 0) {
            filtered.push({
              name: "No Results",
              disabled: true,
            });
          }
          return filtered;
        }}
        getOptionDisabled={(option) => option.disabled}
        disabledItemsFocusable
        classes={{
          option: s.option,
          listbox: s.listbox,
          paper: s.paper,
          endAdornment: s.endAdornment
        }}
        renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              classes={{
                root: s.inputContainer,
              }}
              InputProps={{
                ...params.InputProps,
                classes: {
                  root: s.inputRoot,
                  input: s.input,
                },
                margin: "none",
                disableUnderline: true,
                endAdornment:
                  params.inputProps.value !== "" ? (
                    params.InputProps.endAdornment
                  ) : (
                    <InputAdornment position="end">
                      <IconButton className={s.searchIcon} aria-label="search">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
              }}
              placeholder="Search Students"
              aria-label={ARIA_LABEL_AUTOCOMPLETE}
              margin="none"
            />
          )}
        renderOption={renderOption(optionSelected)}
        onHighlightChange={(event, option) => {
          if (option) {
            setOptionSelected(option.name);
          }
        }}
      />
    </div>
  );
}

export default SearchStudent;
